import { Box } from '@mui/material';
import { ReactNode } from 'react';
import DesignSystem from '../../designSystem';

export function EntityCard({
  children,
  onClick,
  selected = false,
  pad = true,
}: {
  children: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  pad?: boolean;
}) {
  return (
    <Box
      component={onClick ? 'button' : 'div'}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      sx={{
        width: '100%',
        textAlign: 'left',
        font: 'inherit',
        color: 'inherit',
        cursor: onClick ? 'pointer' : 'default',
        bgcolor: selected ? DesignSystem.colors.surfaceElevated : DesignSystem.colors.surface,
        borderRadius: DesignSystem.borderRadius.lg,
        border: 0,
        boxShadow: 'none',
        p: pad ? DesignSystem.layout.cardPad : 0,
        overflow: 'hidden',
        transition: `background-color ${DesignSystem.motion.duration} ${DesignSystem.motion.easing}`,
        '&:hover': onClick ? { backgroundColor: DesignSystem.colors.surfaceElevated } : undefined,
      }}
    >
      {children}
    </Box>
  );
}

export default EntityCard;
